import React, { useState, useEffect } from 'react';
import { Save, User, ShieldAlert } from 'lucide-react';
import Swal from 'sweetalert2';

const SetWithdraw: React.FC = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({ min_withdraw: '', max_loss: '', min_profit: '' });

  useEffect(() => {
    // fetch('http://localhost:10001/api/admin/customers')
    fetch('https://motilalalgo.com/api/admin/customers')
      .then(res => res.json())
      .then(data => { if (data.success) setCustomers(data.users.filter((u: any) => u.login_id)); });
  }, []);

  const handleUserSelect = (e: any) => {
    const user = customers.find(c => c.id === parseInt(e.target.value));
    setSelectedUser(user || null);
    if(user) {
      setFormData({ 
        min_withdraw: user.min_withdraw || '', 
        max_loss: user.max_loss || '', 
        min_profit: user.min_profit || '' 
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUser) return Swal.fire('Error', 'Select a user first', 'error');

    setIsSaving(true);
    try {
    //   const res = await fetch('http://localhost:10001/api/admin/set-withdraw-limits', {
      const res = await fetch('https://motilalalgo.com/api/admin/set-withdraw-limits', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: selectedUser.id, ...formData })
      });
      const data = await res.json();
      if (data.success) Swal.fire('Saved!', 'Withdrawal conditions applied to user.', 'success');
      else Swal.fire('Error', data.error, 'error');
    } catch (error) {
      Swal.fire('Error', 'Update failed', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex justify-between">
        <div>
          <h1 className="text-2xl font-black text-slate-800">Set Withdraw Limits</h1>
          <p className="text-sm text-slate-500 mt-1">Define conditions a user must meet before withdrawing funds.</p>
        </div>
        <ShieldAlert size={36} className="text-[#3b36a4]" />
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2 flex items-center gap-2"><User size={14}/> Select Customer</label>
            <select onChange={handleUserSelect} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-800 outline-none">
              <option value="">-- Choose a Customer --</option>
              {customers.map(c => <option key={c.id} value={c.id}>{c.first_name} {c.last_name} (ID: {c.login_id})</option>)}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Min Withdraw Amount (₹)</label>
              <input type="number" required value={formData.min_withdraw} onChange={e => setFormData({...formData, min_withdraw: e.target.value})} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" placeholder="e.g. 2500" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Max Allowed Loss (₹)</label>
              <input type="number" required value={formData.max_loss} onChange={e => setFormData({...formData, max_loss: e.target.value})} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-red-600" placeholder="e.g. 1000" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Min Profit Required (₹)</label>
              <input type="number" required value={formData.min_profit} onChange={e => setFormData({...formData, min_profit: e.target.value})} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-green-600" placeholder="e.g. 500" />
            </div>
          </div>

          <button type="submit" disabled={isSaving} className="w-full bg-[#3b36a4] hover:bg-[#2d2780] text-white font-black py-4 rounded-xl shadow-lg transition-all flex justify-center gap-2">
            <Save size={20} /> {isSaving ? 'Saving...' : 'Set Limits'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default SetWithdraw;